// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fb487ec3","510":"4865ad7d","777":"b329faed"}[chunkId] + ".chunk.js";
};